
import React from "react";
import Slider from "react-slick";
import { Box, Button, CardMedia, Grid, Typography } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GetHomeofferimage } from "../../../client-api/ApiHomeBanner";
import { Bannerimages } from "../../../Icons/Reuseheading";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ReplayIcon from "@mui/icons-material/Replay";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
const ArrowButton = ({ onClick, direction }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        left: direction === "prev" ? 16 : "auto",
        right: direction === "next" ? 16 : "auto",
        width: 56,
        height: 56,
        backgroundColor: "#0b0b0b",
        color: "#fff",
        borderRadius: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2,
        cursor: "pointer",
        "&:hover": { backgroundColor: "#111" },
      }}
      aria-label={direction === "prev" ? "Previous slide" : "Next slide"}
    >
      <Typography sx={{ fontSize: 22, lineHeight: 1 }}>
        {direction === "prev" ? "←" : "→"}
      </Typography>
    </Box>
  );
};

const Slide = ({ image, title, subtitle }) => {
  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: 420, md: 560 },
        backgroundColor: "#0f0f0f",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          
          backgroundImage: `url(${Bannerimages}/${image})`,
          backgroundRepeat: "no-repeat",
  backgroundSize: { md: "contain" ,lg:"contain", xs: "contain",sm:'contain'  },
          //  backgroundSize: { xs: "120%", md: "cover" },
          backgroundPosition: { xs: "60% 60%", md: "85% center" },
          Height: {lg:"500px",xs:"220px",sm:"420px",md:"560px"},
                    
          // opacity: 0.35,
          // filter: "blur(0px)",
        }}
      />
    </Box>
  );
};

const HomeHeroSlider = () => {
  const { data, isLoading } = GetHomeofferimage();

  if (isLoading) return <Typography sx={{ p: 2 }}>Loading...</Typography>;
  if (!data || data.length === 0)
    return <Typography sx={{ p: 2 }}>No banner data available</Typography>;

  const slides = data.slice(0, Math.min(6, data.length));

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
    pauseOnHover: true,
    arrows: true,
    prevArrow: <ArrowButton direction="prev" />,
    nextArrow: <ArrowButton direction="next" />,
    adaptiveHeight: false,
  };

  return (<>
    {/* <Box sx={{ position: "relative", backgroundColor: "#0f0f0f" ,}}>
          <Slider {...settings}>
            {slides.map((item, idx) => (
      <div>
   <img src={`${Bannerimages}/${item?.image}`} alt={item?.name} />
      </div>
        ))}
    </Slider> */}




    <Box sx={{ position: "relative", backgroundColor: "#0f0f0f" }}>
  <Slider {...settings}>
    {slides.map((item, idx) => (
      <div key={idx}>
        <img
          src={`${Bannerimages}/${item?.image}`}
          alt={item?.name}
          style={{
            width: "100%",
             height: "450px",
    //         height: {
    //   xs: 250,
    //   sm: 350,
    //   md: 450,
    //   lg: 500,
    // },
          }}
        />
      </div>
    ))}
  </Slider>


      {/* <Slider {...settings}>
        {slides.map((item, idx) => (
          <Slide
            key={idx}
            image={item?.image || ""}
            title={item?.name || ""}
            subtitle={item?.description || ""}
          />
        ))}
      </Slider> */}
    </Box>

        <Box
      sx={{
        backgroundColor: "#fef9f9ff",
        borderTop: "3px solid #f6c40d",
          borderBottom: "3px solid #f6c40d",
        py: 1.5,
      }}
    >
    <Grid
      container
      justifyContent="space-around"
      alignItems="center"
      spacing={2}
      sx={{ padding: ".5rem 1rem" }}
    >
      {features.map((item, index) => (
        <Grid item xs={6} sm={6} md={3} key={index}>
          <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
        
{/* 
         <CardMedia
                                  component="img"
                                  alt={data?.[0]?.product?.name}
                                  image={item.img} 
                                  sx={{
                                    objectFit: "unset",
                                    height: 50,
                                    borderRadius: "10px",
                                    maxWidth: 50,
                                    margin: "auto",
                                  }}
                                /> */}
                                <img src={item.img} alt={item.txt} style={{height:30, width:30, objectFit:'contain'}} />
            <Typography variant="body1" sx={{ fontWeight: "bold" ,   fontFamily: "CamptonBook",
              fontSize:'.9rem'
            }}>
              {item.txt}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
    </Box>
  </>);
};

export default HomeHeroSlider;


  const whats1 =
    "https://ik.imagekit.io/thmmwwbpc/MFF%20E%20Commerce/logoicons/installation.png?updatedAt=1715237824190";
  const whats2 =
    "https://ik.imagekit.io/thmmwwbpc/MFF%20E%20Commerce/logoicons/secure%20payment.png?updatedAt=1715237824019";
  const whats3 =
    "https://ik.imagekit.io/thmmwwbpc/MFF%20E%20Commerce/logoicons/free%20delivery.png?updatedAt=1715237823945";
  const whats4 =
    "https://ik.imagekit.io/thmmwwbpc/MFF%20E%20Commerce/logoicons/customer-support.png?updatedAt=1715237824201";
  const whats5 =
    "https://ik.imagekit.io/thmmwwbpc/MFF%20E%20Commerce/logoicons/cash-on-delivery.png?updatedAt=1715237823530";
  const whats6 =
    "https://ik.imagekit.io/thmmwwbpc/MFF%20E%20Commerce/logoicons/genuine.png?updatedAt=1715237824026";
  const whats7 =
    "https://ik.imagekit.io/thmmwwbpc/MFF%20E%20Commerce/logoicons/warranty.png?updatedAt=1715237824196";

const features = [
  {
     img: whats1,
    txt: "Free Installation*",
  },
  {
      img: whats2,
      txt: "Secure Payment",
    },
    {
      img: whats3,
      txt: "Free Delivery*",
    },
   
    {
      img: whats6,
      txt: "Genuine",
    },
    
];


